import DeleteIcon from '@/assets/icons/fs-delete.svg?react'
import DownloadIcon from '@/assets/icons/fs-download.svg?react'
import MoveIcon from '@/assets/icons/fs-move.svg?react'
import RenameIcon from '@/assets/icons/fs-rename.svg?react'
import { cn } from '@/utils/style'

import { IFile } from '../fs'

interface HoverActionsProps {
  file: IFile
  onDownload: () => void
  onMove: () => void
  onRename: () => void
  onDelete: () => void
  disableEdit?: boolean
}

/**
 * Hover actions component for file table rows
 * Shows action buttons on hover instead of fixed action column
 */
export function HoverActions({
  file,
  onDownload,
  onMove,
  onRename,
  onDelete,
  disableEdit = false,
}: HoverActionsProps) {
  return (
    <div
      className={cn(
        'absolute right-0 top-1/2 -translate-y-1/2',
        'hidden group-hover:flex gap-1',
        'pl-4',
      )}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Download - disabled for directories */}
      <button
        aria-label="Download"
        className={cn(
          'p-1.5 rounded-md transition-colors',
          file.isDir
            ? 'text-tertiary cursor-not-allowed'
            : 'text-secondary hover:bg-panel-gray-200 hover:text-primary',
        )}
        onClick={onDownload}
        disabled={file.isDir}
        title="Download"
      >
        <DownloadIcon className="w-4 h-4" />
      </button>

      {/* Move - disabled when editing is disabled */}
      <button
        aria-label="Move"
        className={cn(
          'p-1.5 rounded-md transition-colors',
          disableEdit
            ? 'text-tertiary cursor-not-allowed'
            : 'text-secondary hover:bg-panel-gray-200 hover:text-primary',
        )}
        onClick={onMove}
        disabled={disableEdit}
        title="Move"
      >
        <MoveIcon className="w-4 h-4" />
      </button>

      {/* Rename - disabled when editing is disabled */}
      <button
        aria-label="Rename"
        className={cn(
          'p-1.5 rounded-md transition-colors',
          disableEdit
            ? 'text-tertiary cursor-not-allowed'
            : 'text-secondary hover:bg-panel-gray-200 hover:text-primary',
        )}
        onClick={onRename}
        disabled={disableEdit}
        title="Rename"
      >
        <RenameIcon className="w-4 h-4" />
      </button>

      {/* Delete - disabled when editing is disabled */}
      <button
        aria-label="Delete"
        className={cn(
          'p-1.5 rounded-md transition-colors',
          disableEdit
            ? 'text-tertiary cursor-not-allowed'
            : 'text-secondary hover:bg-error/10 hover:text-error',
        )}
        onClick={onDelete}
        disabled={disableEdit}
        title="Delete"
      >
        <DeleteIcon className="w-4 h-4" />
      </button>
    </div>
  )
}
